import {Component, Input} from '@angular/core';
import {Property} from '../../../../shared/property/property.model';
import {AppUtils} from '../../../../shared/app-utils';
import {ConfigStructure} from '../../../../config/config-structure.model';
import {AppConfigService} from '../../../../config/app-config.service';
import {TranslatorService} from '../../../../shared/translator.service';
import {DescriptorLink} from '../../../../shared/property/descriptor-link.model';
import {TranslateService} from '../../../../shared/translate.service';

@Component({
  selector: 'app-work-details',
  templateUrl: './work-details.component.html',
  styleUrls: ['./work-details.component.css']
})
export class WorkDetailsComponent {

  @Input() work: any;

  properties: Property[] = [];

  authors: DescriptorLink[] = [];

  constructor(private translator: TranslatorService,
              private appConfig: AppConfigService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    this.properties = AppUtils.mapObjectToProperties(this.work);
    let property = this.getAuthors();
    if (property) {
      this.authors = property.value;
    }
  }

  getAuthors() {
    let property = this.translator.find(this.properties, 'work_presentation_main_creator');
    if (property && property.value && Array.isArray(property.value)) {
      property.value.forEach((prop) => {
        property = this.translator.find(prop, 'value');
      });
    }
    return property;
  }

  getConfig(): ConfigStructure[] {
    return this.appConfig.workDetailsConfig.workDetailsConfig;
  }

  getStatistics(): string {
    let statString = this.work['stat_materialization_count'] ? this.work['stat_materialization_count'] : 0;
    statString += ' ' + this.translateService.translate('work.count.part1');
    statString += ' ';
    statString += this.work['stat_item_count'] ? this.work['stat_item_count'] : 0;
    statString += ' ' + this.translateService.translate('work.count.part2');
    statString += ' ';
    statString += this.work['stat_library_count'] ? this.work['stat_library_count'] : 0;
    statString += ' ' + this.translateService.translate('work.count.part3');
    return statString;
  }

  getLibraries(): string {
    let libString = this.work['stat_digital_library_count'] ? this.work['stat_digital_library_count'] : 0;
    libString += ' ' + this.translateService.translate('work.count.part4');
    return libString;
  }

  getWorkLink(): string {
    return '/work/' + this.work['work_host_item_work_uuid'][0];
  }
}
